/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ParameterAttributes.
* @enum {}
* @readonly
*/
export default class ParameterAttributes {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 4
         * @const
         */
        "4" = 4;

    
        /**
         * value: 8
         * @const
         */
        "8" = 8;

    
        /**
         * value: 16
         * @const
         */
        "16" = 16;

    
        /**
         * value: 4096
         * @const
         */
        "4096" = 4096;

    
        /**
         * value: 8192
         * @const
         */
        "8192" = 8192;

    
        /**
         * value: 16384
         * @const
         */
        "16384" = 16384;

    
        /**
         * value: 32768
         * @const
         */
        "32768" = 32768;

    
        /**
         * value: 61440
         * @const
         */
        "61440" = 61440;

    

    /**
    * Returns a <code>ParameterAttributes</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ParameterAttributes} The enum <code>ParameterAttributes</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

